// Dashboard'da gosterilen SAT Talep ozet kartlari (5 asamali akis).
// Rol bazli:
//  - Her kullanici: acik taleplerim (any pending_*)
//  - Birim amiri (manager_id'si kendisi olan kullanicilari olan): pending_supervisor
//  - IT: pending_it
//  - company_manager / admin: pending_manager
//  - HR / admin: pending_hr
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../providers/I18nProvider";
import { useAuth } from "../../contexts/AuthContext";
import { hasAnyRole } from "../../utils/roles";
import { satRequestService } from "../../services/satRequestService";

const Card = ({ label, value, onClick, tone = "neutral" }) => {
  const bg =
    tone === "warn" ? "#fff3cd" :
    tone === "ok" ? "#e2f0e2" :
    tone === "info" ? "#e4ecff" :
    "#f3f4f6";
  const color =
    tone === "warn" ? "#855a00" :
    tone === "ok" ? "#1f5a22" :
    tone === "info" ? "#2e4ea8" :
    "#333";
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: bg,
        color,
        border: "none",
        borderRadius: 10,
        padding: "12px 14px",
        textAlign: "left",
        cursor: onClick ? "pointer" : "default",
        minWidth: 140,
      }}
    >
      <div style={{ fontSize: "1.6rem", fontWeight: 700, lineHeight: 1.1 }}>
        {value}
      </div>
      <div style={{ fontSize: "0.78rem", opacity: 0.85, marginTop: 4 }}>{label}</div>
    </button>
  );
};

const SATDashboardWidget = () => {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    satRequestService
      .stats()
      .then((d) => {
        if (!cancelled) setStats(d);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.msg || err.message);
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading)
    return (
      <div style={{ padding: 12, color: "#666", fontSize: "0.85rem" }}>
        {t("common.loading")}
      </div>
    );
  if (error)
    return <div style={{ padding: 12, color: "#c33", fontSize: "0.85rem" }}>{error}</div>;
  if (!stats) return null;

  const isIT = hasAnyRole(user, ["it", "admin"]);
  const isManager = hasAnyRole(user, ["company_manager", "admin"]);
  const isHr = hasAnyRole(user, ["hr", "admin"]);
  // Supervisor kartini her kullaniciya gosteriyoruz; backend supervisor_mine=1
  // ile sadece astlarin sayisi doner (astlari yoksa 0 gorulur).

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 10,
        padding: 14,
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: 10,
        }}
      >
        <h3 style={{ margin: 0, fontSize: "1rem" }}>{t("satRequest.title")}</h3>
        <button
          type="button"
          onClick={() => navigate("/sat-requests")}
          style={{
            border: "none",
            background: "transparent",
            color: "#2c6af0",
            cursor: "pointer",
            fontSize: "0.82rem",
          }}
        >
          {t("satRequest.newRequest")} →
        </button>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <Card
          label={t("satRequest.widget.myOpen")}
          value={stats.myOpen || 0}
          onClick={() => navigate("/sat-requests")}
          tone={stats.myOpen > 0 ? "info" : "neutral"}
        />
        {typeof stats.awaitingSupervisor === "number" && (
          <Card
            label={t("satRequest.widget.awaitingSupervisor")}
            value={stats.awaitingSupervisor}
            onClick={() => navigate("/admin/sat-requests")}
            tone={stats.awaitingSupervisor > 0 ? "warn" : "neutral"}
          />
        )}
        {isIT && (
          <Card
            label={t("satRequest.widget.awaitingIt")}
            value={stats.awaitingIt || 0}
            onClick={() => navigate("/admin/sat-requests")}
            tone={stats.awaitingIt > 0 ? "warn" : "neutral"}
          />
        )}
        {isManager && (
          <Card
            label={t("satRequest.widget.awaitingManager")}
            value={stats.awaitingManager || 0}
            onClick={() => navigate("/admin/sat-requests")}
            tone={stats.awaitingManager > 0 ? "warn" : "neutral"}
          />
        )}
        {isHr && (
          <Card
            label={t("satRequest.widget.awaitingHr")}
            value={stats.awaitingHr || 0}
            onClick={() => navigate("/admin/sat-requests")}
            tone={stats.awaitingHr > 0 ? "warn" : "neutral"}
          />
        )}
      </div>
    </div>
  );
};

export default SATDashboardWidget;
